import React, { useEffect } from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import useUserStorage from "../../Reusable/useUserStorage.js";
import Progressbar from "components/Reusable/Progressbar/Progressbar.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import { useUser } from "contexts/userContext/userContext.js";
import Button from "components/Elements/Button/Button.js";
import { LinkToNewTab } from "components/Elements/Link/Link.js";

const NoMailSelectedSplitMenu = () => {
  const { getTextByKey } = useContent();
  const { getUserData } = useUser();
  const { sizeInUse, sizeMax, percantegeOfSpace } = useUserStorage();

  return (
    <div className="no-mail-selected">
      <div className="title">{getTextByKey("no-email-selected")}</div>
      {getUserData()?.IsSubscribed ? (
        <div className="user-storage-message">
          <Progressbar
            completed={percantegeOfSpace}
            color={
              percantegeOfSpace > 95
                ? "#a90500"
                : percantegeOfSpace > 75
                ? "#d9534f"
                : "#15B4D4"
            }
            height="8px"
            animation={100}
          />
          <div className="storage-message">
            {getTextByKey("storage-message")
              .replace("%Value%", `${sizeInUse.size}${sizeInUse.type}`)
              .replace("%Value%", `${sizeMax.size}${sizeMax.type}`)}
            <Icon name="newInbox/shopping-cart-outlined" large />
          </div>
        </div>
      ) : (
        <div className="not-subscriber-wrapper">
          <p>{getTextByKey("no-items-not-subscriber")}</p>
          <LinkToNewTab page="plans" isNewTab>
            <Button white>
              {getTextByKey("no-items-see-plans")}
            </Button>
          </LinkToNewTab>
        </div>
      )}
    </div>
  );
};

export default NoMailSelectedSplitMenu;
